import { PropType, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import TaskEntity from '@/entity/TaskEntity';
import TempWorkerEntity from '@/entity/temp-worker/TempWorkerEntity';

type Props = SetupProps<typeof TempWorkerTaskListSetupService.props>

export default class TempWorkerTaskListSetupService extends BaseSetupService<Props> {
	static readonly props = {
		taskList: {
			type: Array as PropType<TaskEntity[]>,
			default: () => [],
		},
		taskType: {
			type: Number,
			required: true as const,
		},
		tempWorker: {
			type: Object as PropType<TempWorkerEntity>,
			required: true as const,
		},
	};

	private readonly state = reactive({
		toggleDone: false,
		taskTypeOptions: { CandidateTask: 1 }, // Ajouter d'autres types de task
	});

	get isCandidateTask () { return this.props.taskType === this.state.taskTypeOptions.CandidateTask; }
	get listIsEmpty () { return this.props.taskList?.length === 0; }

	get tasks () {
		return this.state.toggleDone
			? this.props.taskList
			: this.props.taskList.filter(x => x.isPassed === false);
	}

	get orderedTasks () {
		return [...this.tasks].sort((a, b) => (a.startDate?.valueOf() ?? 0) - (b.startDate?.valueOf() ?? 0));
	}

	get toggleDone () { return this.state.toggleDone; }
	set toggleDone (val) { this.state.toggleDone = val; }


	constructor (props?: Props) {
		super(props);
	}


	async addTaskAsync () {
		new TaskEntity().associateTempWorker(this.props.tempWorker).openModalEdit();
	}
}
